<template>
  <div>
    <title-bar title="单位编辑">
      <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
      <el-button type="default" @click="cancel()">取消</el-button>
    </title-bar>
    <div class="page-body">
      <el-form ref="editForm" :model="company" label-width="80px" :rules="validateRules"
               style="width: 800px;margin:auto">
        <el-form-item label="单位名称" prop="compName">
          <el-input v-model="company.compName" clearable placeholder="请输入单位名称模糊查询"></el-input>
        </el-form-item>
        <el-form-item label="单位类型" prop="compType">
          <code-select v-model="company.compType" code-type="COMP_TYPE"></code-select>
        </el-form-item>
        <el-form-item label="单位层级" prop="compLevel">
          <code-select v-model="company.compLevel" code-type="areaLevel"></code-select>
        </el-form-item>
        <el-form-item label="所属区域" prop="provCode" v-if="company.compLevel">
          <area-cascader v-model="areaCodes" :level="company.compLevel" @change="areaChange"></area-cascader>
        </el-form-item>
        <el-form-item label="停运日期" prop="stopDay">
          <code-select code-type="WEEKDAY" v-model="company.stopDay"></code-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="valid">
          <el-switch v-model="company.valid"></el-switch>
        </el-form-item>
      </el-form>
      <div class="button-container">
        <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
        <el-button type="default" @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import AreaCascader from "@/components/base/AreaCascader.vue";
export default {
  name: 'CompanyEdit',
  components: {AreaCascader, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      areaCodes: [],
      company: {
        compName: '',
        compType: '',
        compLevel: '',
        provCode: null,
        cityCode: null,
        townCode: null,
        stopDay: null,
        valid: true
      },
      records: [],
      validateRules: {
        compName: [{required:true, message:'单位名称不能为空', trigger: 'blur'}],
        compType: [{required:true, message:'单位类型不能为空', trigger: 'change'}],
        compLevel: [{required:true, message:'单位层级不能为空', trigger: 'change'}],
        provCode: [{required:true, message:'所属区域不能为空', trigger: 'change'}]
      }
    }
  },
  created() {
    let compId = this.$route.query.compId;
    if(compId) {
      this.loading = true;
      this.postForm("/company/getById?compId="+compId,null,true).then(dr=>{
        this.company = dr.bean;
        if(this.company.provCode) {
          this.areaCodes.push(this.company.provCode);
        }
        if(this.company.cityCode) {
          this.areaCodes.push(this.company.cityCode);
        }
        if(this.company.townCode) {
          this.areaCodes.push(this.company.townCode);
        }
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  methods: {
    save(){
      this.$refs.editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/company/saveCompany", this.company, true).then(dr => {
            this.$router.back();
          }).finally(()=>{
            this.loading = false;
          });
        }
      });
    },
    cancel(){
      this.$router.back();
    },
    areaChange(areaCodes){
      if(areaCodes.length > 0) {
        this.company.provCode = areaCodes[0];
        if(areaCodes.length > 1) {
          this.company.cityCode = areaCodes[1];
        }
        if(areaCodes.length > 2) {
          this.company.townCode = areaCodes[2];
        }
      } else {
        this.company.provCode = null;
        this.company.cityCode = null;
        this.company.townCode = null;
      }
      console.log(this.areaCodes)
      console.log(this.company)
    }
  }
}
</script>

<style scoped>

</style>